import { createStyles } from "@mantine/emotion";

export const useStylesTipTapEditor = createStyles((theme) => {
  return {
    editor: {
      maxWidth: theme.spacing.tipTapEditor.width.editor,
      [`@media (max-width: ${theme.breakpoints.tabletMax})`]: {
        maxWidth: theme.spacing.tipTapEditor.width.editorMobile,
      },
      ".mantine-RichTextEditor-toolbar": {
        padding: theme.spacing.tipTapEditor.padding.toolbar,
        gap: theme.spacing.tipTapEditor.gap.toolbar,
        background: "none",

        ".mantine-RichTextEditor-controlsGroup": {
          background: "none",
          button: {
            minWidth: theme.spacing.tipTapEditor.size.button.minWidth,
            height: theme.spacing.tipTapEditor.size.button.height,
            svg: {
              width: theme.spacing.tipTapEditor.size.icon.width,
              height: theme.spacing.tipTapEditor.size.icon.height,
            },
          },
        },
      },
      ".mantine-RichTextEditor-content": {
        background: "none",
        ".tiptap": {
          padding: theme.spacing.tipTapEditor.padding.content,
        },
      },
    },
    editorPopUp: {
      maxWidth: "100%",
      [`@media (max-width: ${theme.breakpoints.tabletMax})`]: {
        maxWidth: "100%",
      },
      ".mantine-RichTextEditor-content": {
        ".tiptap": {
          minHeight: theme.spacing.tipTapEditor.height.content,
        },
      },
    },
  };
});
